/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import { addSeminarRequest, editSeminarRequest, seminarCategories, seminars } from '../../apis/admin/seminar';
import { isEmpty, remove } from 'lodash';
import { isNumber } from '../../utils/validator';
import { toast } from '../../utils/toast';

const defaultForm = {
  isHide: "false",
  memo: "",
  minPeople: "0",
  price: "0",
};

const SeminarRequest = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState("create");
  const [content, setContent] = useState({});
  const [checkedList, setCheckedList] = useState([]);

  const [categories, setCategories] = useState([]);
  const [seminarList, setSeminarList] = useState([]);

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setForm(defaultForm);
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };


  const _submit = (form) => {
    const thumbnailIdx = !isEmpty(form.thumbnailFile)
      ? isNumber(form.thumbnailFile[form.thumbnailFile.length - 1])
        ? form.thumbnailFile[form.thumbnailFile.length - 1]
        : form.thumbnailFile[form.thumbnailFile.length - 1]?.idx
      : null;
    const mainImageIdx = !isEmpty(form.mainImageFile)
      ? isNumber(form.mainImageFile[form.mainImageFile.length - 1])
        ? form.mainImageFile[form.mainImageFile.length - 1]
        : form.mainImageFile[form.mainImageFile.length - 1]?.idx
      : null;
    const data = {
      ...form,
      thumbnailIdx,
      mainImageIdx,
    };

    delete data?.idx;

    if (mode === "create") {
      addSeminarRequest(data).then(() => {
        toast.success("등록이 완료되었습니다.");
        cancel();
        submit && submit();
      });
    } else {
      editSeminarRequest(form.idx, data).then(() => {
        toast.success("수정이 완료되었습니다.");
        cancel();
        submit && submit();
      });
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  const getSeminars = () => {
    seminars().then(res => {
      const { rows } = res;
      setSeminarList(rows.map(item => ({ ...item, label: item.title, value: item.idx })));
    });
  };

  const getFields = () => {
    const _fields = [
      ...(mode === "create" ? [
        {
          title: "세미나 선택",
          key: "seminar",
          type: "select",
          className: "zIndex-0",
          options: {
            list: () => [
              ...seminarList.map(item => {
                return { label: item.title, value: item.idx + "" };
              })
            ]
          },
        },
      ] : []),
      [
        {
          title: "카테고리 선택",
          key: "categories",
          type: "checkboxes",
          required: true,
          className: "margin-right-16",
          checkedList,
          options: {
            list: categories || [],
          },
          onChange: (checked, value) => {
            let _selectedCheckboxes = [];
            if (checked) {
              _selectedCheckboxes = [...checkedList, value];
            } else {
              _selectedCheckboxes = remove(checkedList, (v) => v !== value);
            }
            setCheckedList(_selectedCheckboxes);
          }
        },
      ],
      [
        {
          title: "목록 노출 여부",
          key: "isHide",
          type: "radio",
          options: {
            list: [{ label: '노출', value: "false" }, { label: '숨김', value: "true" }]
          },
        },
      ],
      [
        {
          title: "썸네일",
          type: "file-upload",
          key: "thumbnailFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
        },
      ],
      [
        {
          key: "title",
          title: "제목",
          type: "input",
          required: true,
        },
        {
          key: "topic",
          title: "주제",
          type: "input",
        },
      ],
      [
        {
          key: "slogan",
          title: "슬로건",
          type: "input",
        }
      ],
      [
        {
          key: "lecturer",
          title: "강연자",
          type: "input",
        },
        {
          key: "target",
          title: "대상",
          type: "input",
        },
      ],
      [
        {
          key: "minPeople",
          title: "최소인원",
          type: "number",
        },
        {
          key: "price",
          title: "금액",
          type: "input",
          validators: ['comma'],
        },
      ],
      [
        {
          title: "대표이미지",
          type: "file-upload",
          key: "mainImageFile",
          required: false,
          isAdmin: true,
          changeDefaultFile: true,
        },
      ],
      [
        {
          title: "내용",
          key: "content",
          type: "editor",
          required: true,
          onChange: (e) => {
            setContent(e);
          }
        },
      ],
    ];
    return _fields;
  };

  const getCategories = () => {
    seminarCategories({ isHideView: true }).then(res => {
      setCategories(res.rows?.map(item => ({ ...item, label: item.name, value: item.idx + "" })));
    });
  };

  const getSeminarDefaultData = (seminarIdx = (seminarList || [])[0]?.idx) => {
    const seminar = seminarList.find(f => f.idx === +seminarIdx) || {};
    return {
      title: seminar.title,
      lecturer: seminar.lecturer,
      maxPeople: seminar.maxPeople,
      content: seminar.content,
      refundPolicy: seminar.refundPolicy,
      target: seminar.target || "",
      topic: seminar.topic || "",
      thumbnailFile: !isEmpty(seminar.thumbnailFile) ? [seminar.thumbnailFile] : [],
      slogan: seminar.slogan || "",
    };
  };

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    if (open && !isEmpty(mode)) {
      getSeminars();
      getCategories();
    }
  }, [open, mode]);

  useEffect(() => {
    setTimeout(() => {
      setFields(getFields());
    }, 10);
  }, [mode, seminarList, categories, form, checkedList]);

  useEffect(() => {
    if (!isEmpty(form.seminar)) {
      setForm(getSeminarDefaultData(+form.seminar));
    }
  }, [form.seminar]);

  useEffect(() => {
    if (!isEmpty(seminarList) && open) {
      setMode(selectedItem ? 'detail' : 'create');
      if (selectedItem) {
        // const seminar = selectedItem?.seminar?.idx + "";
        setForm({
          ...selectedItem,
          isHide: selectedItem.isHide + "",
          price: selectedItem.price + "",
        });
        setOriginForm({
          ...selectedItem,
          isHide: selectedItem.isHide + "",
          price: selectedItem.price + "",
        });
        setCheckedList((selectedItem.seminarCategories || []).map(item => item.idx + ""));
      } else {
        setForm({
          ...defaultForm,
          ...getSeminarDefaultData()
        });
        setOriginForm({
          ...defaultForm,
          ...getSeminarDefaultData()
        });
      }
    }
  }, [open, selectedItem, seminarList]);

  useEffect(() => {
    if (!isEmpty(content)) {
      handleOnChange(content);
    }
  }, [content]);

  useEffect(() => {
    handleOnChange({ categories: checkedList.map(item => ({ order: 0, idx: item })) });
  }, [checkedList]);

  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`요청 세미나 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default SeminarRequest;